import React, {useEffect, useState} from 'react';
import {Button, Text, TextField} from '@cloudaper/react';
import AppHeader from '../AppHeader';

const Invitation = props => {
  const {validateRouteToken, handleUpdateUser, handleRedirectToDm} = props;

  useEffect(() => {
    document.title = 'Aktivace účtu - Začněte s Document Managerem';

    validateRouteToken('invitation');
  }, [validateRouteToken]);

  const [name, setName] = useState('');
  const [nameError, setNameError] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState(false);
  const [passwordCheck, setPasswordCheck] = useState('');
  const [passwordCheckError, setPasswordCheckError] = useState(false);

  const [processing, setProcessing] = useState(false);

  return (
    <>
      <AppHeader />

      <div className="appWrapper">
        <div className="appContent">
          <Text className="appHeading centeredText">Než začnete</Text>
          <br />
          <Text className="centeredText cardBodyText">
            Vyplňte své jméno, případně i telefon, a nastavte si heslo.
          </Text>

          <br />
          <TextField
            disabled={processing}
            helper
            handleEnter={() => {}}
            label="Jméno"
            onChange={e => setName(e.target.value)}
            value={name}
            id="dm-onboarding-invitation-1-1"
            onFocus={() => setNameError(false)}
            onBlur={() => setNameError(true)}
            error={nameError && !name && 'Zadejte jméno'}
          />

          <br />
          <TextField
            disabled={processing}
            helper
            handleEnter={() => {}}
            label="Telefon (nepovinné)"
            onChange={e => setPhoneNumber(e.target.value)}
            value={phoneNumber}
            id="dm-onboarding-invitation-1-3"
            type="tel"
          />

          <br />
          <TextField
            disabled={processing}
            helper="Zadejte nejméně 8 znaků."
            handleEnter={() => {}}
            label="Nové heslo"
            onChange={e => setPassword(e.target.value)}
            value={password}
            id="dm-onboarding-invitation-1-4"
            onFocus={() => setPasswordError(false)}
            onBlur={() => setPasswordError(true)}
            type="password"
            error={
              passwordError && password.length < 8 && 'Heslo je příliš krátké'
            }
          />

          <br />
          <TextField
            disabled={processing}
            helper="Pro kontrolu napište heslo ještě jednou."
            handleEnter={() => {}}
            label="Nové heslo znovu"
            onChange={e => setPasswordCheck(e.target.value)}
            value={passwordCheck}
            id="dm-onboarding-invitation-1-5"
            onFocus={() => setPasswordCheckError(false)}
            onBlur={() => setPasswordCheckError(true)}
            type="password"
            error={
              passwordCheckError &&
              password !== passwordCheck &&
              'Hesla se neshodují'
            }
          />

          <div className="routeButtons">
            <Button
              disabled={
                processing ||
                !name ||
                !password ||
                password.length < 8 ||
                password !== passwordCheck
              }
              kind="primary"
              onClick={async () => {
                setProcessing(true);
                const status = await handleUpdateUser(
                  name,
                  phoneNumber || undefined,
                  password,
                  'invitation',
                );
                if (status === 200) {
                  handleRedirectToDm();
                }
              }}
              raised
            >
              {processing ? 'Zpracovávám' : 'Potvrdit'}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Invitation;
